exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".largelogin{background:#fff}.largelogin>.body{margin:15px 25%}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/booker/LargeLogin.vue"],"names":[],"mappings":"AACA,YACE,eAAkB,CACnB,AACD,kBACE,eAAiB,CAClB","file":"LargeLogin.vue","sourcesContent":["\n.largelogin {\n  background: white;\n}\n.largelogin > .body {\n  margin: 15px 25%;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f1421f16","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/booker/LargeLogin.vue
// module id = 874
// module chunks = 2